import {IconsObject} from '@/icons/services/IconService';

const icons: IconsObject = {
  addNew: 'mdi-book-plus',
};

export default icons;
